<template>
  <div>
    <b-modal
      v-model="deleteconfirm"
      hide-footer
      title="Remove group member from the group?"
    >
      This operation will remove this group member from the group.
      <b-button
        class="mt-3"
        variant="danger"
        block
        @click="deletegroupmember(delete_id)"
      >
        Remove from group
      </b-button>
      <b-button
        class="mt-2"
        variant="secondary"
        block
        @click="deleteconfirm=false;delete_id=0;"
      >
        Cancel
      </b-button>
    </b-modal>
    <b-form
      novalidate
      @submit.stop.prevent
    >
      <div class="d-flex justify-content-start mt-3">
        <b-button @click.prevent="toggleaddmember" variant="primary" class="gdq-button">
          Add group member
        </b-button>
      </div>
      <div class="d-flex justify-content-start mt-3 w-100">
        <div v-if="addmember" class="w-100">
          <b-form class="bg-secondary add-member-container" novalidate @submit.stop.prevent>
            <b-form-group class="">
              <label class="">
                Form Type
              </label>
              <b-form-select v-model="groupmember_formoption_id" :options="formoptions" />
            </b-form-group>
            <b-form-group :state="groupmember_email_valid" v-show="groupmember_formoption_id == 1" class="">
              <label class="col-12 pl-0">
                Email address
              </label>
              <input v-model="groupmember_email" class="form-control col-12" :class="`${anon ? 'g-anon' : ''}`"
                :state="groupmember_email_valid" type="text"
                :placeholder="'Email Address'">
              <span v-show="groupmember_email_valid == 'invalid'" class="text-danger">Invalid or duplicate email
                address</span>
              <span v-show="groupmember_email_valid != 'invalid'">&nbsp;</span>
            </b-form-group>
            <b-form-group class="button-group mb-0">
              <div class="text-right">
                <b-button variant="primary" @click.prevent="addgroupmember">
                  <span class="d-inline-block d-md-none d-lg-inline-block">
                    Add
                  </span>
                </b-button>
                <b-button variant="danger" class="ml-2" @click="toggleaddmember">
                  <span class="d-inline-block d-md-none d-lg-inline-block">Cancel</span>
                </b-button>
              </div>
            </b-form-group>
          </b-form>
        </div>
      </div>

      <!-- <h3>Group members</h3> -->
      <b-table :fields="fields" :class="'actions-table save-cancel'" :items="groupmembers"
      :tbody-tr-class="rowClass">
      >
        <template v-slot:head(select)>
          <b-form-checkbox
            v-model="selected"
            @click.native.stop
          />
        </template>
        <template v-slot:cell(groupsurveymember_survey_code)="data">
          {{ data.item.groupsurveymember_survey_code }}
        </template>

        <template v-slot:cell(groupmember_email)="data">
          <div class="position-relative">
            <div class="uneditable" v-if="!data.item.editable" :class="{ 'g-anon': anon }">{{ data.item.groupmember_email }}</div>
            <b-form-input
                v-else
                v-model="data.item.groupmember_email"
                type="text"
                :class="{'g-anon': anon, 'text-danger': data.item.groupmember_email_valid == 'invalid'}"
              />
              <i
                v-if="data.item.groupmember_email_valid == 'invalid' && data.item.editable"
                class="fa-solid inline-tooltip fa-circle-question tooltip-question tooltip-danger"
                v-b-tooltip="'Invalid email address'"
              ></i>
          </div>
        </template>
        <template v-slot:cell(groupmember_formoption_id)="data">
          <div class="uneditable" v-if="!data.item.editable">{{
            getFormOptionText(data.item.groupmember_formoption_id) }}
          </div>
          <b-form-select v-else="data.item.editable"
            v-model="data.item.groupmember_formoption_id" :options="formoptions"
          />
        </template>
        <template v-slot:cell(actions)="data">
          <div class="d-flex justify-content-end">
            <div v-if="data.item.editable">
              <b-button variant="danger" class="btn-tiny mr-1"
                @click.prevent="cancelEdit(data.item.id)">Cancel</b-button>
              <b-button variant="primary" class="btn-tiny"
                @click.prevent="saveEdit(data.item.id)">Save</b-button>
            </div>
            <b-dropdown right class="ml-2">
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <b-dropdown-item @click.prevent="editGroupMember(data.item.id)">Edit</b-dropdown-item>
              <b-dropdown-item @click.prevent.stop="deleteconfirm=true;delete_id=data.item.id">Remove from group</b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </b-table>
      <b-row class="pb-4 mx-auto">
      </b-row>
    </b-form>
  </div>
</template>
<script>
const fields = [
  { key: 'groupmember_code', label: 'Member', tdClass: 'col gdq-w-50px', thClass: 'col gdq-w-50px' },
  { key: 'groupmember_email', label: 'Email', tdClass: 'col', thClass: 'col' },
  { key: 'groupmember_formoption_id', label: 'Form', tdClass: 'col', thClass: 'col' },
  { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
]
export default {
  props: {
    mode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selected: 'o',
      fields: fields,
      rows: 4,
      perPage: 3,
      currentPage: 1,
      group_id: this.$store.state.currentgroup_id,
      currentgroup: {},
      groupmember_name: '',
      groupmember_name_valid: null,
      groupmember_email: '',
      groupmember_email_valid: null,
      groupmember_mobile: '',
      groupmember_mobile_valid: null,
      groupmember_formoption_id: 1,
      addingmember: false,
      editingmember: 0,
      editingfield: '',
      groupmembers: [],
      groupmembers_grid: [],
      languages: [],
      formoptions: [],
      original_member_data: {},
      addmember: false,
      deleteconfirm: false,
      delete_id: 0
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    }
  },
  created () {
    this.group_get()
    this.languages_get()
    this.formoptions_get()
    this.groupmembers_get()
  },
  methods: {
    toggleaddmember () {
      this.cleargroupmember()
      this.addmember = !this.addmember
      this.contactmembers = false
      this.sendinvitations = false
    },
    rowClass (item, index) {
      return item.editable ? 'editable-row' : ''
    },
    editGroupMember (id) {
      for (let i = 0; i < this.groupmembers_grid.length; i++) {
        if (this.groupmembers_grid[i].id === id) {
          if (this.groupmembers_grid[i].editable) {
            this.groupmembers_grid[i].editable = false
          } else {
            // Cancel edit for all other rows
            this.groupmembers_grid.forEach((member, index) => {
              if (index !== i) {
                this.cancelEdit(member.id)
              }
            })
            this.groupmembers_grid[i].editable = true
            this.original_member_data[id] = JSON.parse(JSON.stringify(this.groupmembers_grid[i]))
          }
        }
      }
    },
    async saveEdit (id) {
      const index = this.groupmembers_grid.findIndex(member => member.id === id)
      // Existing member
      if (index !== -1) {
        const member = this.groupmembers_grid[index]
        const original = this.original_member_data[id]
        const originalEmail = original.groupmember_email || ''
        if (this.validateEditedMember(member)) {
          if (member.groupmember_email != originalEmail) {
            member.groupsurveymember_status_id = 1
            this.groupmembers_grid[index].groupsurveymember_status_id = 1
          }
          member.editable = false
          await this.$store.dispatch('groupmember_save', { groupmember: member })
          this.groupmembers_get()
          this.formchanged = false
          delete this.original_member_data[id]
        } else {
          member.groupmember_email_valid = 'invalid'
          const mail = member.groupmember_email
          member.groupmember_email = ''
          member.groupmember_email = mail
        }
      }
    },
    validateEditedMember (member) {
      if (member.groupmember_formoption_id != 1) {
        member.groupmember_email_valid = null
        member.groupmember_email = ''
        return true
      } else {
        return this.parse_email(member.groupmember_email)
      }
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(email.toLowerCase())
    },
    cancelEdit (id) {
      const index = this.groupmembers_grid.findIndex(member => member.id === id)
      if (index !== -1 && this.original_member_data[id]) {
        this.groupmembers_grid[index].groupmember_code = this.original_member_data[id].groupmember_code
        this.groupmembers_grid[index].groupmember_email = this.original_member_data[id].groupmember_email
        this.groupmembers_grid[index].groupmember_formoption_id = this.original_member_data[id].groupmember_formoption_id
        this.groupmembers_grid[index].editable = false
        delete this.original_member_data[id]
      }
    },
    group_get () {
      this.$store.dispatch('group_fetch')
        .then((resp) => {
          this.currentgroup = resp.data
        })
    },
    languages_get () {
      const filter = {
        language_enabled: {
          operator: '=',
          value: '1'
        }
      }
      this.$store.dispatch('languages_fetch', { filter })
        .then((resp) => {
          this.languages = resp.data.result.map((l) => {
            return {
              value: l.id,
              text: l.language_name
            }
          })
        })
    },
    formoptions_get () {
      this.$store.dispatch('formoptions_fetch')
        .then((resp) => {
          this.formoptions = resp.data.result.map((l) => {
            return {
              value: l.id,
              text: l.formoption_name
            }
          })
        })
    },
    getFormOptionText (id) {
      const option = this.formoptions.find(option => option.value === id)
      return option ? option.text : ''
    },
    groupmembers_get () {
      this.$store.dispatch('groupmembers_fetch', { group_id: this.group_id })
        .then((resp) => {
          const readmembers = resp.data.result
          let groupmembers = []
          for (var i = 0; i < readmembers.length; i++) {
            let groupmember_formoption_name = 'None'
            for (var j = 0; j < this.formoptions.length; j++) {
              if (readmembers[i].groupmember_formoption_id == this.formoptions[j].value) {
                groupmember_formoption_name = this.formoptions[j].text
              }
            }
            var groupmember = {
              id: readmembers[i].id,
              groupmember_code: readmembers[i].groupmember_code,
              groupmember_name: readmembers[i].groupmember_name,
              groupmember_email: readmembers[i].groupmember_email,
              groupmember_mobile: readmembers[i].groupmember_mobile,
              groupmember_formoption_id: readmembers[i].groupmember_formoption_id,
              groupmember_formoption_name: groupmember_formoption_name,
              editable: false
            }
            groupmembers.push(groupmember)
          }
          this.groupmembers = groupmembers
          this.groupmembers_grid = groupmembers
        })
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    inputgroupmember (flag) {
      this.addingmember = flag
    },
    cleargroupmember () {
      this.groupmember_name = ''
      this.groupmember_email = ''
      this.groupmember_mobile = ''
      this.inputgroupmember(false)
    },
    validategroupmember (name, email, mobile, formoption_id, language_id) {
      var result = []
      var formok = true
      var thismessage = ''
      this.groupmember_name_valid = null
      this.groupmember_email_valid = null
      this.groupmember_mobile_valid = null
      // Online form
      if (formoption_id == 1) {
        if (email == '') {
          this.groupmember_email_valid = false
          formok = false
        }
        if (!this.parse_email(email)) {
        // // eslint-disable-next-line
        // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false) {
          this.groupmember_email_valid = false
          formok = false
        }
        // ------------------------------
        // Check for duplicates - e-mail
        // ------------------------------
        for (var j = 0; j < this.groupmembers.length; j++) {
          if (this.groupmembers[j].groupmember_email == email) {
            formok = false
            this.groupmember_email_valid = false
          }
        }
      }
      result['formok'] = formok
      return result
    },
    addgroupmember () {
      var validate =
          this.validategroupmember(
            // this.groupmember_name,
            this.groupmember_email,
            // this.groupmember_mobile,
            this.groupmember_formoption_id
          )
      // Here save IMMEDIATELY, POST HASTE
      if (validate['formok'] == true) {
        var code = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2).toUpperCase()
        code = code + Math.round(Math.random() * (9999 - 1000) + 1000, 0)
        code = this.groupmembers.length + 1
        var groupmember = {
          group_id: this.group_id,
          groupmember_email: this.groupmember_email,
          groupmember_code: code.toString(),
          groupmember_formoption_id: this.groupmember_formoption_id
        }
        this.$store.dispatch('groupmember_create', { 'groupmember': groupmember })
          .then(() => {
            this.cleargroupmember()
            this.inputgroupmember(false)
            this.group_get()
            this.groupmembers_get()
          })
      }
    },
    deletegroupmember (id) {
      this.$store.dispatch('groupmember_delete', { 'id': id })
        .then(() => {
          this.deleteconfirm = false
          this.delete_id = 0
          this.groupmembers_get()
        })
    },
    savefield (id, fieldname, value) {
      if (!this.loading) {
        if (fieldname.indexOf('_date') != -1) {
          value = this.format_date(value)
        }
        if (fieldname.indexOf('_time') != -1) {
          if (value != null && value != '') {
            value = this.format_time(value)
          } else {
            value = '00:00'
          }
        }
        var data = {
          id,
          [fieldname]: value
        }
        this.formchanged = false
        this.$store.dispatch('groupmember_save', { groupmember: data })
      }
    }
  }
}
</script>
<style scoped>
</style>
